// 深入研究（lingzhi-studio）：一个问题拆成几路分头查资料，补查一次，写成带出处的报告。和灵智原生同源、同一个登录令牌。
import { request } from './client'

const BASE = '/studio/api/research'

export type ResearchPhase = 'planning' | 'searching' | 'reflecting' | 'writing' | 'done' | 'failed'
export const RESEARCH_RUNNING: ResearchPhase[] = ['planning', 'searching', 'reflecting', 'writing']

export type SourceKind = 'mine' | 'project' | 'daily' | 'think' | 'collected'

export interface ResearchSource {
  n: number
  knowledgeId: string
  kbId: string
  title: string
  kind: SourceKind
  date?: string
  passages: string[]
  hits: number
}

export interface ResearchQuery {
  q: string
  round: 1 | 2
  found: number
}

export interface ResearchSession {
  id: string
  question: string
  scope: { knowledgeBaseIds: string[]; knowledgeIds: string[]; label?: string }
  phase: ResearchPhase
  aspects: string[]
  queries: ResearchQuery[]
  gaps: string[]
  sources: ResearchSource[]
  report: string
  error?: string
  calls: number
  createdAt: string
  updatedAt: string
  /** 这一遍从什么时候开始（重试会重新算）。 */
  startedAt?: string
  finishedAt?: string
}

export interface ResearchSummary {
  id: string
  question: string
  phase: ResearchPhase
  createdAt: string
  updatedAt: string
}

export interface CreateResearch {
  question: string
  knowledgeBaseIds: string[]
  knowledgeIds: string[]
  /** 网页缩小过范围时的说明（只在「我写的」里找……）。 */
  label?: string
}

const one = (p: Promise<unknown>) => p.then((r) => (r as { data: ResearchSession }).data)

export const listResearch = () => request<{ data: ResearchSummary[] }>(BASE).then((r) => r.data ?? [])
export const getResearch = (id: string) => one(request(`${BASE}/${id}`))
export const createResearch = (input: CreateResearch) => one(request(BASE, { body: input }))
export const retryResearch = (id: string) => one(request(`${BASE}/${id}/retry`, { body: {} }))
export const deleteResearch = (id: string) => request(`${BASE}/${id}`, { method: 'DELETE' })

export const KIND_LABEL: Record<SourceKind, string> = { mine: '我写的', project: '项目资料', daily: '日报', think: '以前的判断', collected: '收集的' }
